module.exports = __webpack_public_path__ + "img/eyebrow_female_arched_thick.1e8146a0.png";